import getGlobalSettingsAccountMailboxInfo from "owa-account-source-list-store/lib/selectors/getGlobalSettingsAccountMailboxInfo";
import { logUsage } from "owa-analytics";
import { getCurrentModule } from "owa-app-module-store";
import getSelectedTableView from "owa-mail-list-store/lib/utils/getSelectedTableView";
import { lazyManualSyncMail } from "owa-mail-manual-sync";

export default function onSyncButtonClicked(): void {
    if (getCurrentModule() !== "Mail") {
        return;
    }
    
    const tableView = getSelectedTableView();
    if (!tableView) {
        return;
    }
    
    logUsage("SyncButtonClicked", getGlobalSettingsAccountMailboxInfo(), {
        source: "Header",
    });
    lazyManualSyncMail.importAndExecute(tableView);
}
